import { render } from "./GetInstantQuote.vue?vue&type=template&id=707dff52&scoped=true"
import script from "./GetInstantQuote.vue?vue&type=script&lang=js"
export * from "./GetInstantQuote.vue?vue&type=script&lang=js"

import "./GetInstantQuote.vue?vue&type=style&index=0&id=707dff52&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707dff52"]])

export default __exports__